import React from 'react';
import cn from 'classnames';

import {useContentCardContext} from '../../ContentCard';

import {IContentCardLinksProps} from './IContentCardLinks';

import styles from './ContentCardLinks.module.scss';

const ContentCardLinks = (props: IContentCardLinksProps) => {
	const {style} = useContentCardContext();

	return (
		<div className={cn(
			'content-card__links',
			styles['content-card__links'],
			{[styles[`content-card__links--${style}`]]: style}
		)}>
			{props.children}
		</div>
	);
};

export default ContentCardLinks;
